//import axios from '@/libs/api.request'
import config from '@/config/index'
import axios from 'axios'



export const getInfoView = (id, expand) => {

    return axios.request({
        url: config.baseUrl + '/api/info/info/view',
        params: {
            id: id,
            expand
        },
        method: 'get'
    })
};

export const getNav = (key) => {
    return axios.request({
        url: config.baseUrl + '/api/info/info/nav',
        params: {
            key
        },
        method: 'get'
    })
};
export const putSuggest = ({ title, content }) => {
    const data = {
        title,
        content
    }
    return axios.request({
        url: config.baseUrl + '/api/info/info/suggest',
        data,
        method: 'post'
    })
}